import { debounce } from 'lodash-es';

interface State {
  isWishlistSidebarOpen: boolean;
  isLoginDrawerOpen: boolean;
  loginAuthType: 'default' | 'checkout';
  isResetPasswordModalOpen: boolean;
  isCategoryGridView: boolean;
  isFilterSidebarOpen: boolean;
  isMobileMenuOpen: boolean;
  isEfficiencySidebarOpen: boolean;
  isForgotPasswordView: boolean;
  isRegisterCustomerView: boolean;
  isDesktopNavigationOpen: boolean;
  isRedirectDialogOpen: boolean;
  showAddToCartNotification: boolean;
}

const state = ref<State>({
  isWishlistSidebarOpen: false,
  isLoginDrawerOpen: false,
  loginAuthType: 'default',
  isResetPasswordModalOpen: false,
  isCategoryGridView: true,
  isFilterSidebarOpen: false,
  isMobileMenuOpen: false,
  isEfficiencySidebarOpen: false,
  isForgotPasswordView: false,
  isRegisterCustomerView: false,
  isDesktopNavigationOpen: false,
  isRedirectDialogOpen: false,
  showAddToCartNotification: false,
});
const useUiState = () => {
  const isCheckout: Ref<boolean> = useState('isCheckout');
  const showRedirectModal = () => {
    state.value.isRedirectDialogOpen = true;
  };
  const hideRedirectModal = () => {
    state.value.isRedirectDialogOpen = false;
  };

  const toggleMobileMenu = () => {
    state.value.isMobileMenuOpen = !state.value.isMobileMenuOpen;
  };

  const showMobileMenu = () => {
    state.value.isMobileMenuOpen = true;
  };

  const closeMobileMenu = () => {
    state.value.isMobileMenuOpen = false;
  };

  const toggleWishlistSidebar = () => {
    if (state.value.isMobileMenuOpen) {
      toggleMobileMenu();
    }

    state.value.isWishlistSidebarOpen = !state.value.isWishlistSidebarOpen;
  };

  const toggleLoginDrawer = (authType: 'default' | 'checkout' = 'default') => {
    if (state.value.isMobileMenuOpen) {
      toggleMobileMenu();
    }
    state.value.loginAuthType = authType;
    state.value.isLoginDrawerOpen = !state.value.isLoginDrawerOpen;
    if (!state.value.isLoginDrawerOpen) {
      isCheckout.value = false;
    }
  };

  const showLoginDrawer = () => {
    if (state.value.isMobileMenuOpen) {
      showMobileMenu();
    }
    state.value.loginAuthType = 'default';
    state.value.isLoginDrawerOpen = true;
  };

  const closeLoginDrawer = () => {
    if (state.value.isMobileMenuOpen) {
      closeMobileMenu();
    }
    state.value.loginAuthType = 'default';

    if (state.value.isLoginDrawerOpen) {
      toggleLoginDrawer();
    }
  };

  const toggleResetPasswordModal = () => {
    if (state.value.isMobileMenuOpen) {
      toggleMobileMenu();
    }

    state.value.isResetPasswordModalOpen = !state.value.isResetPasswordModalOpen;
  };

  const changeToCategoryGridView = () => {
    state.value.isCategoryGridView = true;
  };
  const changeToCategoryListView = () => {
    state.value.isCategoryGridView = false;
  };

  const toggleFilterSidebar = () => {
    state.value.isFilterSidebarOpen = !state.value.isFilterSidebarOpen;
    document.body.style.overflow = state.value.isFilterSidebarOpen ? 'hidden' : 'auto';
  };

  const closeFilterSidebar = () => {
    state.value.isFilterSidebarOpen = false;
    document.body.style.overflow = 'auto';
  };

  const toggleEfficiencySidebar = () => {
    if (state.value.isMobileMenuOpen) {
      toggleMobileMenu();
    }

    state.value.isEfficiencySidebarOpen = !state.value.isEfficiencySidebarOpen;
    document.body.style.overflow = state.value.isEfficiencySidebarOpen ? 'hidden' : 'auto';
  };

  const closeEfficiencySidebar = () => {
    state.value.isEfficiencySidebarOpen = false;
    document.body.style.overflow = 'auto';
  };

  const setForgotPasswordView = (val: boolean) => {
    state.value.isForgotPasswordView = val;
  };

  const setDesktopNavigationOpen = debounce((status) => {
    state.value.isDesktopNavigationOpen = status;
  }, 100);

  return {
    isWishlistSidebarOpen: computed(() => state.value.isWishlistSidebarOpen),
    isLoginDrawerOpen: computed(() => state.value.isLoginDrawerOpen),
    loginAuthType: computed(() => state.value.loginAuthType),
    isResetPasswordModalOpen: computed(() => state.value.isResetPasswordModalOpen),
    isCategoryGridView: computed(() => state.value.isCategoryGridView),
    isFilterSidebarOpen: computed(() => state.value.isFilterSidebarOpen),
    isMobileMenuOpen: computed(() => state.value.isMobileMenuOpen),
    isEfficiencySidebarOpen: computed(() => state.value.isEfficiencySidebarOpen),
    isForgotPasswordView: computed(() => state.value.isForgotPasswordView),
    isDesktopNavigationOpen: computed(() => state.value.isDesktopNavigationOpen),
    isRedirectDialogOpen: computed(() => state.value.isRedirectDialogOpen),
    showAddToCartNotification: computed(() => state.value.showAddToCartNotification),

    showRedirectModal,
    hideRedirectModal,
    toggleWishlistSidebar,
    showLoginDrawer,
    closeLoginDrawer,
    toggleLoginDrawer,
    toggleResetPasswordModal,
    changeToCategoryGridView,
    changeToCategoryListView,
    toggleFilterSidebar,
    closeFilterSidebar,
    toggleMobileMenu,
    closeEfficiencySidebar,
    toggleEfficiencySidebar,
    setForgotPasswordView,
    setDesktopNavigationOpen,
  };
};

export default useUiState;
